import React from 'react';
import Counter from '../ReusableComponents/counter';

//MUI
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Container } from '@mui/system';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Woman2RoundedIcon from '@mui/icons-material/Woman2Rounded';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';

//Images
import im1 from '../../assets/images/SDG/1.jpg';
import im5 from '../../assets/images/SDG/5.jpg';
import im11 from '../../assets/images/SDG/11.jpg';
import im16 from '../../assets/images/SDG/16.jpg';
import bg from '../../assets/images/background.svg';
import P4 from '../../assets/images/cardImages/stakeholder_interest.jpg';
import P4_small from '../../assets/images/cardImages/mobile/stakeholder_interest.jpg';

const counterData = [
    {
        "num": 6,
        "label": "Key stakeholders engaged with on various material topics",
        "icon": WorkspacesIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 68.9,
        "label": "Value chain partners trained on Sustainability Topics",
        "icon": LocalShippingIcon,
        "prefix": "",
        "isdecimal": true,
        "suffix": "%"
    },
    {
        "num": 462704,
        "label": "Number of women empowered through women empowerment projects",
        "icon": Woman2RoundedIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": ""
    },
    {
        "num": 0,
        "label": "CSR Award for outstanding contribution",
        "icon": MilitaryTechIcon,
        "prefix": "ET Now Champions",
        "isdecimal": true,
        "suffix": ""
    },
    {
        "num": 0,
        "label": "for Corporate Social Responsibility",
        "icon": MilitaryTechIcon,
        "prefix": "Golden peacock Award",
        "isdecimal": true,
        "suffix": ""
    },
    {
        "num": 0,
        "label": "Skill Development and Employability Category",
        "icon": MilitaryTechIcon,
        "prefix": "SIAM CSR Award 2026",
        "isdecimal": true,
        "suffix": ""
    }
]


const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const StyledBox = styled(Box)`
  ${({ theme }) => `
  cursor: pointer;
  transition: ${theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.standard,
})};
  &:hover {
    transform: scale(2);
  }
  `}
`;


const Sectionc4 = () => {
    const [expanded1, setExpanded1] = React.useState(false);
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };

    const [expanded2, setExpanded2] = React.useState(false);
    const handleExpandClick2 = () => {
        setExpanded2(!expanded2);
    };

    const [expanded3, setExpanded3] = React.useState(false);
    const handleExpandClick3 = () => {
        setExpanded3(!expanded3);
    };

    const [expanded4, setExpanded4] = React.useState(false);
    const handleExpandClick4 = () => {
        setExpanded4(!expanded4);
    };

    const [expanded5, setExpanded5] = React.useState(false);
    const handleExpandClick5 = () => {
        setExpanded5(!expanded5);
    };

    const [expand, setExpand] = React.useState(false);
    const expandAll = () => {
        setExpand(true);
        setExpanded1(true);
        setExpanded2(true);
        setExpanded3(true);
        setExpanded4(true);
        setExpanded5(true);
    };
    const closeAll = () => {
        setExpand(false);
        setExpanded1(false);
        setExpanded2(false);
        setExpanded3(false);
        setExpanded4(false);
        setExpanded5(false);
    };


    return (
        <Container>
            <Box mt={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button startIcon={<WestIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc3'>
                    Previous
                </Button>
                <Button endIcon={<EastIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc5'>
                    Next
                </Button>
            </Box>
            <Box mt={3} sx={{
                display: 'flex',
                alignItems: 'center',
                height: { xs: '150px', md: '300px' },
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                borderRadius: '8px'
            }}>
                <Box px={5} py={3} sx={{ width: '100%' }}>
                    <Typography sx={{ typography: { xs: 'h5', md: 'h4' }, color: "#ffffff" }}>
                        Principle 4
                    </Typography>
                    <Typography mt={2} sx={{ typography: { xs: 'body1', md: 'h6' }, color: "#ffffff" }}>
                        Stakeholder Interest
                    </Typography>
                    <Box mt={2} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <Typography variant='body1' sx={{ color: "#ffffff" }}>
                            Businesses should respect the interests of and be responsive to all its stakeholders
                        </Typography>
                    </Box>
                    <Box mt={3} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <StyledBox><img src={im1} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im5} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im11} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im16} height="40" alt="svg" /></StyledBox>
                    </Box>
                </Box>
                <Box sx={{
                    backgroundImage: { xs: `url(${P4_small})`, sm: `url(${P4})` },
                    backgroundSize: 'cover',
                    borderRadius: '0 8px 8px 0',
                    height: { xs: '150px', md: '300px' },
                    width: '100%'
                }}>
                </Box>
            </Box>
            <Box px={4} py={6} mt={{ xs: 4, md: 8 }} sx={{ backgroundColor: '#e6e7e8', borderRadius: '8px' }}>
                <Box mb={6} display="flex" justifyContent="center">
                    <Typography className='heading' variant='h4' sx={{ color: "#e31837", fontSize: "34px", fontWeight: "900" }}>
                        Highlights
                    </Typography>
                </Box>
                <Box>
                    <Counter data={counterData} />
                </Box>
            </Box>
            <Box mt={5} sx={{ textAlign: "right" }}>
                <button onClick={!expand ? expandAll : closeAll} className="custom-button">
                    <span>
                        {!expand ? 'Expand All' : "Close All"}
                        {!expand ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </span>
                </button>
            </Box>
            <Box mt={4}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Essential Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Describe the processes for identifying key stakeholder groups of the entity.
                            <ExpandMore
                                expand={expanded1}
                                onClick={handleExpandClick1}
                                aria-expanded={expanded1}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded1} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            The Company identifies its stakeholders based on the Value Chain of the businesses and how they influence the Company. The Company also believes in being a neighbour of choice and works in consultation with neighbourhood communities in and around the vicinity of its business operation as well as in some of the aspirational districts beyond the neighbourhood.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            2. List stakeholder groups identified as key for your entity and the frequency of engagement with each stakeholder group.
                            <ExpandMore
                                expand={expanded2}
                                onClick={handleExpandClick2}
                                aria-expanded={expanded2}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded2} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: { xs: 1200, md: 650 } }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Stakeholder Group</strong></TableCell>
                                        <TableCell><strong>Whether identified as Vulnerable & Marginalized Group (Yes/ No) </strong></TableCell>
                                        <TableCell><strong>Channels of communication (Email, SMS, Newspaper, Pamphlets, Advertisement, Community Meetings, Notice Board, Website), Other</strong></TableCell>
                                        <TableCell><strong>Frequency of engagement (Annually/ Half yearly/ Quarterly/ others - please specify)</strong></TableCell>
                                        <TableCell><strong>Purpose and scope of engagement including key topics and concerns raised during such engagement</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>Shareholders</TableCell>
                                        <TableCell align='center'>No</TableCell>
                                        <TableCell>
                                            Website, E-mail, Newsletters, dissemination
                                            of information on the website of the Stock
                                            Exchanges, Press Releases, Annual Reports,
                                            General Meetings, Institutional Investors
                                            Meets
                                        </TableCell>
                                        <TableCell>Quarterly/Event-based</TableCell>
                                        <TableCell>
                                            Dissemination of information having a bearing on the
                                            performance/operations of
                                            the Company including price sensitive information, updating
                                            Shareholders on various statutory requirements with
                                            respect to their shareholding in the Company, addressing
                                            shareholders’ queries at the General Meetings, earnings call
                                            with institutional investors/ analysts in respect of quarterly/
                                            half-yearly/annual financial results
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>Employees</TableCell>
                                        <TableCell align='center'>No</TableCell>
                                        <TableCell>
                                            Website, E-mail, Newsletters
                                        </TableCell>
                                        <TableCell>Regular</TableCell>
                                        <TableCell>
                                            Open &amp; transparent
                                            communication. Addressing
                                            employees’ questions &amp;
                                            clarifications
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>Community</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell>
                                            Community Meetings
                                        </TableCell>
                                        <TableCell>
                                            Regular
                                        </TableCell>
                                        <TableCell>
                                            Project progress and benefits.
                                            Wellbeing, empowerment and
                                            awareness initiatives extended
                                            to communities through an
                                            inclusive approach to foster trust
                                            among community partners
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>Suppliers</TableCell>
                                        <TableCell align='center'>No</TableCell>
                                        <TableCell>
                                            Website, E-mail, Newsletters
                                        </TableCell>
                                        <TableCell>Regular</TableCell>
                                        <TableCell>
                                            Business Model Resilience,
                                            Supply Chain Management,
                                            Materials Sourcing &amp; Material
                                            Efficiency
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>
                                            Dealers
                                        </TableCell>
                                        <TableCell align='center'>No</TableCell>
                                        <TableCell>Website, E-mail</TableCell>
                                        <TableCell>
                                            Regular
                                        </TableCell>
                                        <TableCell>
                                            Service Quality, Sustainability &amp;
                                            Creating Customer Delight
                                        </TableCell>
                                    </TableRow>

                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>
                                            Customer
                                        </TableCell>
                                        <TableCell align='center'>No</TableCell>
                                        <TableCell>Website, E-mail, Newsletters</TableCell>
                                        <TableCell>
                                            Regular
                                        </TableCell>
                                        <TableCell>
                                            Product Quality &amp; Safety, Selling
                                            Practices &amp; Product Labelling,
                                            Access &amp; Affordability
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={6}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Leadership Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Provide the processes for consultation between stakeholders and the Board on economic, environmental, and social topics or if consultation is delegated, how is feedback from such consultations
                            provided to the Board.
                            <ExpandMore
                                expand={expanded3}
                                onClick={handleExpandClick3}
                                aria-expanded={expanded3}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded3} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Engaging with stakeholders is crucial to ensure that the Company’s decisions and actions are in line with their expectations. As a key driver of sustainable and responsible business practices, it fosters trust and collaboration, drives innovation and manages risks effectively. Our leadership engages through multiple platforms to ensure stakeholder feedback on economic, environmental, and social matters meaningfully informs organizational decision-making.
                            <br /><br />
                            Please refer to the Stakeholder Engagement Section of the Company’s Sustainability Report to understand how the Company engages with diverse stakeholder groups to consult on economic, environmental and social topics.
                            <br /><br />
                            The Corporate Social Responsibility (CSR) committee of the Board of Directors also has ESG under its purview. The CSR Committee sets a direction for ESG and CSR Agenda for the Company and other group companies. The Company also has a Sustainability Council chaired by Dr. Anish Shah, Group CEO and Managing Director and consists of all the Group Executive Board (GEB) members. The Council approves new initiatives and monitors progress of integration of the ESG parameters in business and operations.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            2. Whether stakeholder consultation is used to support the identification and management of environmental, and social topics (Yes/ No). If so, provide details of instances as to how the inputs received
                            from stakeholders on these topics were incorporated into policies and activities of the entity.
                            <ExpandMore
                                expand={expanded4}
                                onClick={handleExpandClick4}
                                aria-expanded={expanded4}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded4} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Yes, as part of the Company’s materiality assessment, environmental, social and governance (ESG) issues, that are significant and relevant to the Company’s operation and stakeholders, are identified. The materiality process involves a collaborative mapping exercise that engages all stakeholders in the identification of key issues. Top management engagement and stakeholder consultations lead to the development of a final material assessment matrix and a strategic roadmap. Please refer to the ‘rise for an equal world’ section of the Annual Report to learn more about measures the Company has undertaken as part of the materiality assessment process that was undertaken.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} mb={5} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            3. Provide details of instances of engagement with, and actions taken to, address the concerns of vulnerable/ marginalized stakeholder groups.
                            <ExpandMore
                                expand={expanded5}
                                onClick={handleExpandClick5}
                                aria-expanded={expanded5}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded5} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            The key material issue in social capital is CSR management, where we focus on formulating community-centric policies and implementing a sustainable strategy.
                            <br></br><br></br>
                            As per the Company’s CSR Policy and in alignment with its core purpose, the CSR mission focuses on:
                            <ul>
                                <li>Empower Girls through education</li>
                                <li>Empower Women through skills training</li>
                                <li>Support women by strengthening maternity and newborn healthcare</li>
                                <li>Water Conservation</li>
                            </ul>
                            Some of our key initiatives include:
                            <ol>
                                <li>Project Nanhi Kali: The flagship CSR initiative supports the education of girls from economically disadvantaged backgrounds across India. The program focuses on learners from Grades 6 to 10 through targeted educational and sports initiatives.</li>
                                <li>Kaabil: This initiative empowers women by providing industry-relevant skills training aligned with emerging market needs. The program offers training across three pathways: Employability Skilling, Domain Skilling, and Agri-Skilling, to enhance livelihood opportunities and long-term economic independence.</li>
                                <li>Maternity and Newborn Health care: This initiative focuses on addressing critical gaps in maternal and early-life healthcare. The program aims to improve maternal and newborn health outcomes, laying the foundation for healthier families and communities.</li>
                                <li>Jal Samriddhi (Water Conservation): As a part of its environmental conservation efforts, the company implements climate-resilient water management and conservation. Through community participation and ownership, the program undertakes water conservation projects across diverse geographies to prevent soil erosion, improve soil health, and enhance groundwater recharge through the creation and strengthening of water structures.</li>
                            </ol>
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
        </Container>
    )
}


export default Sectionc4;